import { Box, TextField, Button, CircularProgress } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { Formik, Form } from "formik";
import { useChat } from "../context/ChatContext";
import { useState } from "react";

const ChatInput = () => {
	const { addChat, sendChat } = useChat();
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = async (values: { question: string }) => {
		setIsLoading(true);
		try {
			handleNewChat(values.question, false);
			await sendChat(values.question);
		} finally {
			setIsLoading(false);
		}
	};

	const handleNewChat = (text: string, isResponse: boolean) => {
		addChat({ text, isResponse });
	};

	return (
		<Box sx={{ position: "sticky", bottom: 10 }}>
			<Formik
				initialValues={{ question: "" }}
				onSubmit={(values, { resetForm }) => {
					handleSubmit(values);
					resetForm();
				}}
			>
				{({ values, handleChange, handleBlur, errors, touched }) => (
					<Form>
						<TextField
							fullWidth
							name="question"
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.question}
							placeholder="Ask Elena a question..."
							multiline
							maxRows={4}
							error={touched.question && Boolean(errors.question)}
							helperText={touched.question && errors.question}
							InputProps={{
								endAdornment: isLoading ? (
									<CircularProgress size={24} sx={{ color: "#7B2855" }} />
								) : (
									<Button
										type="submit"
										disabled={isLoading}
										sx={{ color: "#7B2855" }}
									>
										<SendIcon />
									</Button>
								),
								style: { borderRadius: 20 },
							}}
						/>
					</Form>
				)}
			</Formik>
		</Box>
	);
};

export default ChatInput;
